export default __webpack_public_path__ + "static/media/modifier.f42f6076.svg";